<template>
  <div class="wrapper-full" :style="`height:${dispH}px;margin-top:200px`">
    <span
      class="iconfont icon-shutdown1 shoutdown"
      @click="showPowerOff"
      style="font-size: 40px"
    ></span>
    <div style="width: 662px; border: none; border-radius: 10px; padding: 50px; margin: 0 auto">
      <FormLogin @login-success="loginSuccess"></FormLogin>
    </div>
  </div>
</template>
<script>
import FormLogin from "./settings/FormLogin.vue";
import { Message, Size } from "../../mixins";
import fileSys from "../../fileoprators/fileSystem";
export default {
  data() {
    return {
      loginInfo: {
        username: "Admin",
        password: "",
        serverssl: 0,
        serverip: "127.0.0.1",
        serverport: 8080,
        sslport: 4430,
        rememberPassword: false
      }
    };
  },
  components: {
    FormLogin
  },
  methods: {
    loginSuccess() {
      this.$emit("login-success");
    },
    showPowerOff() {
      this.confirm(
        this.$t("langcfg.txtPowerOff"),
        this.$t("langcfg.txtOK"),
        this.$t("langcfg.txtCancel")
      )
        .then(() => {
          document.getElementById("loading").innerHTML = this.$t("langcfg.txtClosingDevice");
          document.getElementById("app").innerHTML = "";
          setTimeout(() => {
            fileSys.powerOff();
          }, 500);
        })
        .catch(() => {});
    }
  },
  mixins: [Size, Message]
};
</script>
<style scoped lang="less">
.input-remember-password {
  padding-top: 0px;
  border: none;
  width: 25px;
  height: 25px;
}
.el-checkbox {
  margin: 0px;
  text-align: left;
}
.el-checkbox /deep/ .el-checkbox__label {
  color: white;
  font-size: 20px;
}
.el-checkbox /deep/ .el-checkbox__inner {
  width: 20px;
  height: 20px;
}

.el-checkbox /deep/ .el-checkbox__inner::after {
  height: 13px;
  width: 10px;
}
.el-checkbox /deep/ .el-checkbox__input {
  vertical-align: middle;
}

.btn-operator:hover {
  color: @btn-hover-color;
  i {
    color: @btn-hover-color;
  }
}
.btn-operator:active {
  background: @btn-active-color;
}
.blue-selected-color {
  color: @blue-selected-color;
}
.btn-operator {
  height: 50px;
  width: 200px;
  font-size: 23px;
}
.margin-top-20 {
  margin-top: 30px;
}
.btn-area {
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/ .el-select .el-input__inner {
  font-size: 20px;
}
.select-http-https {
  /deep/ .el-input__inner {
    border-radius: 4px 0px 0px 4px;
  }
}
.input-server-port {
  /deep/ .el-input__inner {
    border-radius: 0px 4px 4px 0px;
  }
}
.input-server-ip {
  /deep/ .el-input__inner {
    border-radius: 0px;
  }
}
.shoutdown {
  position: absolute;
  top: 15px;
  right: 50px;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/Login.vue